import React from "react";
import { useHistory } from "react-router-dom";
import MCSGrid from "components/MCSGrid";
import MCSGridFluid from "components/MCSGridFluid";
import MCSGridRevert from "components/MCSGridRevert";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import Link from "@visa/vds/link";
import {
    PUBLIC_OVERVIEW,
    PUBLIC_DAF,
    LIBRARY,
    GETTING_STARTED,
    APPROVEDPRODUCTS
} from "_constants/PageRoutes";
import Card from "@visa/vds/card";
import CardContent from "@visa/vds/card-content";
import ButtonText from "@visa/vds/button-text";

function Home() {
    const history = useHistory();
    const overviewClickHandler = () => history.push(PUBLIC_OVERVIEW);
    const dafClickHandler = () => history.push(PUBLIC_DAF);
    const libraryClickHandler = () => history.push(LIBRARY);
    const approvedProductClickHandler = () => history.push(APPROVEDPRODUCTS.APPROVED_PRODUCTS_PUBLIC);
    const gettingStartedClickHandler = (e) => {
        // e.preventDefault();
        history.push(GETTING_STARTED);
    }

    return (
        <>
            <MCSGridRevert className="padding-bottom-large padding-bottom-screen-max-1023">
                <Row>
                    <Col xs={4} md={8} lg={7} xl={8} className="col-vss-content col-vss-justify-start">
                        <Typography tag="h1" variant="headline">Visa Secure with EMV 3DS</Typography>
                        <Typography variant="body" className="vss-text-body-large vss-text-body-justify">
                            Connected devices are growing, exponentially. Consumers want to shop seamlessly and on their preferred devices. But this opportunity for eCommerce has also enticed fraudsters to go digital. Visa Secure with EMV 3DS delivers an extra layer of security. Transactions can be approved with confidence. And consumers and merchants can shop and ship with peace of mind.
                        </Typography>
                        <Link onClick={overviewClickHandler} inline className="vss-link-bold" aria-label="Learn More About Visa Secure with EMV 3DS">Learn More</Link>
                    </Col>
                    <Col xs={3} md={4} lg={5} xl={4} className="col-vss-image">
                        <div className="vss-ilustration-image-panel vss-ilustration-visa-secure-home">
                            <img src="images/public/_blue_yellow-08_1915x1697.png" alt="Visa Secure with EMV 3DS"/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3} md={4} lg={5} xl={4} className="col-vss-image">
                        <div className="vss-ilustration-image-panel">
                            <img src="images/public/_blue_yellow-02_1915x1525.png" alt="Digital Authentication Framework"/>
                        </div>
                    </Col>
                    <Col xs={4} md={8} lg={7} xl={8} className="col-vss-content col-vss-justify-start col-visa-secure-daf-home">
                        <Typography tag="h1" variant="headline">Digital Authentication Framework</Typography>

                        <Typography variant="body" className="vss-text-body-large vss-text-body-justify">
                            DAF enables merchants to deliver frictionless shopping experiences while addressing effective fraud management for eCommerce transactions.
                        </Typography>
                        <Link onClick={dafClickHandler} inline className="vss-link-bold" aria-label="Learn More About Digital Authentication Framework">Learn More</Link>
                    </Col>
                </Row>
            </MCSGridRevert>
            <MCSGridFluid bgColor="light-gray" paddingTop="medium" paddingBottom="large">
                <MCSGrid>
                    <Row>
                        <Col sm={8} md={8} lg={4} className="col-vss-md-block">
                            <Card className="vds-card-float-desktop vds-card-bg-primary" type="content--mini">
                                <CardContent>
                                    <Typography tag="h3" variant="title">Ready to Get Started?</Typography>
                                    <Typography variant="body" className="vss-text-body vss-text-body-justify">Whether you&rsquo;re new to Visa or an existing Visa Secure partner, we&rsquo;ll guide you through the next steps.</Typography>
                                    <ButtonText onClick={gettingStartedClickHandler} colorScheme="secondary" aria-label="Get Started">Get Started</ButtonText>
                                </CardContent>
                            </Card>
                        </Col>
                        <Col sm={8} md={8} lg={4} className="col-vss-md-block">
                            <div className="mcs-box">
                                <div className="mcs-box-content">
                                    <Typography tag="h3" variant="title">VSS Library</Typography>
                                    <Typography variant="body" className="vss-text-body">Access resources to read more about the Visa Secure program.</Typography>
                                    <Link onClick={libraryClickHandler} inline className="vss-link-bold" aria-label="Access Library">Access Library</Link>
                                </div>
                            </div>
                        </Col>
                        <Col sm={8} md={8} lg={4} className="col-vss-md-block">
                            <div className="mcs-box">
                                <div className="mcs-box-content">
                                    <Typography tag="h3" variant="title">Approved Products List</Typography>
                                    <Typography variant="body" className="vss-text-body">View the official list of solutions already compliant with Visa Secure 3D-Secure.</Typography>
                                    <Link onClick={approvedProductClickHandler} inline className="vss-link-bold" aria-label="Find a Vendor">Find a Vendor</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </MCSGrid>
            </MCSGridFluid>
        </>
    );
}

export default Home;
